<template>
  <div id="app" :class="{'app-oce-container': fromOce == 1}">
    <router-view />
    <AIChatBar v-if="enableAI && !['login'].includes($route.name)" />
  </div>
</template>
<script>
import {getLocalStorage, isEnableAI} from '@/utils/index';
import firstMixin from '@/mixins/firstMixin';
import AIChatBar from '@/components/AIChatBar';

export default {
  name: 'App',
  components: {
    AIChatBar
  },
  mixins: [firstMixin],
  data() {
    return {
      fromOce: 0,
    };
  },
  computed: {
    isOce() {
      return this.$store.state.user.isOce || getLocalStorage('isOce');
    },
    enableAI() {
      const routePath = this.$route.fullPath;
      return Boolean(routePath) && isEnableAI();
    },
  },
  watch: {
    isOce(nVal, oVal) {
      this.$set(this, 'fromOce', parseInt(nVal));
    },
  },
  mounted() {
    window.localStorage.removeItem('login-from');
    // this.$set(this, 'fromOce', this.isOce);
    // this.resizeHandler();
    // this.$nextTick(() => {
    //   window.addEventListener('resize', this.resizeHandler);
    // });
    // let userName = getLocalStorage('user_name');
    // if (userName) {
    //   this.$store.dispatch('setWaterMarket');
    // }
  },
  methods: {
    resizeHandler() {
      let self = this;
      setTimeout(() => {
        let navigator = window.navigator;
        // if (navigator.userAgent.includes('iPad')) {
        const isOce = getLocalStorage('login-from');
        if (window.orientation === 180 || window.orientation === 0) {
          // 竖屏
          if (isOce === 'oce') {
            self.$store.dispatch('setOCE', 1);
          }
        }
        if (window.orientation === 90 || window.orientation === -90) {
          // 横屏
          if (isOce === 'oce') {
            self.$store.dispatch('setOCE', 0);
          }
        }
        // }
      }, 800);
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
::v-deep .van-button--info {
  background: #aa341b;
  border: 1px solid #aa341b;
}
::v-deep .van-button--primary {
  background: #aa341b;
  border: 1px solid #aa341b;
}
::v-deep .van-tag--primary.van-tag--plain {
  color: #aa341b;
}
::v-deep .van-button--plain.van-button--info {
  background: transparent;
  color: #aa341b;
}
::v-deep .van-button--plain.van-button--danger {
  color: #22201f;
  border: 1px solid #22201f;
}
::v-deep .van-button--mini.van-button--danger {
  color: #ffffff;
  background: #22201f;
  border: 1px solid #22201f;
}

::v-deep .van-search {
  padding: 6px 6px 2px 6px;
}
</style>
